module.exports = __webpack_public_path__ + "static/media/menu-help.18c768c8.svg";